import React from 'react';
import { hasReactChildren } from 'utils/ui';
import Box from 'components/Box';
import Flex from 'components/Flex';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HeadingWithFilters(_ref) {
  var heading = _ref.heading,
    children = _ref.children;
  var hasFilters = hasReactChildren(children);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: ['column', 'row'],
    align: ['left', 'center'],
    breakpoints: "s",
    mb: "l",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: true,
      shrink: true,
      breakpoints: "s",
      mb: ['m', 0],
      mr: hasFilters ? 'l' : undefined,
      children: heading
    }), hasFilters && /*#__PURE__*/_jsx(Flex, {
      as: "div",
      flexDirection: ['column', 'row'],
      align: ['left', 'center'],
      breakpoints: "xxs",
      gap: ['xs', 'l'],
      children: children
    })]
  });
}